export default __webpack_public_path__ + "static/media/inStoreImg.56283ef0.png";